import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef}                 from "@angular/material/snack-bar";

@Component({
             selector:        'app-snack-alert',
             templateUrl:     './snack-alert.component.html',
             styleUrls:       ['./snack-alert.component.scss'],
             changeDetection: ChangeDetectionStrategy.OnPush,
             standalone:      true,
             imports:         [],
             providers:       []

           })
export class SnackAlertComponent implements OnInit {

  constructor(
    public snackBarRef: MatSnackBarRef<SnackAlertComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }

}
